import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { IconButton } from "@evergis/ui";

import { getMeasurerState } from "../../../../ducks/measurer/selectors";
import { toggleMeasurer } from "../../../../ducks/measurer/measurer";
import { resetMouseLabel } from "../../../../ducks/mouseLabel/mouseLabel";
import { useResetFeatureCard } from "../../../FeatureCard/hooks/useResetFeatureCard";

export const MeasureControlButton = () => {
  const { t } = useTranslation("mapControls");
  const active = useSelector(getMeasurerState);
  const dispatch = useDispatch();

  const measurerClick = useResetFeatureCard(() => {
    dispatch(resetMouseLabel());
    dispatch(toggleMeasurer(!active));
  }, [active, dispatch]);

  return <IconButton primary={active} kind={"measure_length"} title={t("measurements")} onClick={measurerClick} />;
};
